/**
 * Menu width constants
 * NOTE: COLLAPSED and EXPANDED_MIN must stay in sync with
 * $width_menu_collapsed and $width_menu_expanded in
 * /src/styles/_variables.scss
 */
export const MENU_WIDTH_COLLAPSED = 80;
export const MENU_WIDTH_EXPANDED_MIN = 190;
export const MENU_WIDTH_EXPANDED_MAX = 400;

/**
 * Stable id for the primary main window (session restore, RPC client routing,
 * logs). Lives here rather than in `src/utils/windows.ts` so renderer code
 * (e.g. the logger) can use it without importing that main-process module.
 */
export const PRIMARY_WINDOW_ID = "primary";
